import request from './request'

export const newsApi = {
  listNews (params) {
    return request.get('/news', { params: params })
  },
  saveNews (data) {
    return request.post('/news', data)
  },
  deleteNews (id) {
    return request.delete('/news/' + id)
  },
  getNews (id) {
    return request.get('/news/' + id)
  },
  updateNews (id, data) {
    return request.put('/news/' + id, data)
  },
}

export default newsApi
